// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';
import { bool, string } from 'prop-types';
import { useTranslation } from 'react-i18next';

import formatWeeksAndDays from 'Utils/formatWeeksAndDays';

const StyledContainer = styled.div`
  font-size: 14px;
  color: #3A3A3A;

  span {
    font-weight: 600;
  }
`;

const DeliveryEstimate = ({
  estimate,
  isExternalSupplier
}) => {
  const { t } = useTranslation();

  const renderDefaultEstimate = () => isExternalSupplier ? formatWeeksAndDays(estimate) : t('products.deliveryEstimateValues.1-2');

  return (
    <StyledContainer className="deliveryEstimate">
      <span>{ `${ t('products.deliveryEstimate') }: ` }</span>
      { renderDefaultEstimate() }
    </StyledContainer>
  );
};

DeliveryEstimate.propTypes = {
  estimate: string,
  isExternalSupplier: bool,
};

DeliveryEstimate.displayName = 'DeliveryEstimateComponent';

export default DeliveryEstimate;
